<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M2 6.625V10.9436C2.82931 10.2013 3.92445 9.75 5.125 9.75H20.75C21.9506 9.75 23.0457 10.2013 23.875 10.9436V9.75C23.875 8.02411 22.4759 6.625 20.75 6.625H15.1472C14.94 6.625 14.7413 6.54269 14.5948 6.39618L12.3851 4.18647C11.9455 3.74693 11.3494 3.5 10.7278 3.5H5.125C3.39911 3.5 2 4.89911 2 6.625ZM23.875 19.125C23.875 20.8509 22.4759 22.25 20.75 22.25H5.125C3.39911 22.25 2 20.8509 2 19.125V14.4375C2 12.7116 3.39911 11.3125 5.125 11.3125H20.75C22.4759 11.3125 23.875 12.7116 23.875 14.4375V19.125ZM19.1822 14.1092C19.0404 13.7683 18.5575 13.7683 18.4157 14.1092L17.7574 15.6921L16.0485 15.8291C15.6805 15.8586 15.5313 16.3178 15.8116 16.558L17.1136 17.6733L16.7158 19.3409C16.6302 19.7 17.0208 19.9838 17.3359 19.7914L18.799 18.8978L20.262 19.7914C20.5771 19.9838 20.9677 19.7 20.8821 19.3409L20.4843 17.6733L21.7863 16.558C22.0666 16.3178 21.9174 15.8586 21.5494 15.8291L19.8405 15.6921L19.1822 14.1092Z"
				:fill="color" 
			/>
		</svg>

	</div>
</template>

<script>
export default {
	name: 'IconSvgCategories',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>